import type { Personnel } from '../types';

/**
 * « Prenom NOM », ou le seul prenom quand le nom legal manque.
 *
 * Hors du composant de saisie : deux personnel s'appellent Jeremy, et
 * l'affichage doit les distinguer partout, pas seulement dans la liste
 * deroulante. Un fichier qui exporte a la fois un composant et une
 * fonction casse le rafraichissement a chaud.
 */
export function nomPersonnel(personnel: Personnel): string {
  return personnel.nom ? `${personnel.prenom_usuel} ${personnel.nom}` : personnel.prenom_usuel;
}
